export const CONFIRM_EMAIL = '/confirm-email';
export const FORGOT_PASSWORD = '/forgot-password';
export const HEALTHCHECK = '/health-check';
export const LOGIN = '/login';
export const LOGOUT = '/logout';
export const PASSWORD_RESET = '/password-reset';
export const PRODUCTS = '/products';
export const ROOT = '/';
